import { API_URL } from "../config/connect";

/** updatedData: { title?, text?, file? ("" — убрать изображение), notification_type? } */
const editNotification = async (notificationId, updatedData) => {
    const endpoint = `${API_URL}/api/v1/admin/news/${notificationId}`;
    const googleIdToken = localStorage.getItem("google_id_token");
    const response = await fetch(endpoint, {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${googleIdToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const message =
            response.status === 403
                ? "Редактировать уведомления может только администратор."
                : data?.error?.validation_errors?.[0]?.message ||
                  (typeof data?.detail === "string" && data.detail) ||
                  data?.detail?.[0]?.msg ||
                  `Ошибка при обновлении (${response.status})`;
        throw new Error(message);
    }
    return response.json();
};

export default editNotification;
